import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";
import { formatApiError } from "@/lib/api";

export default function Community() {
  const { user } = useAuth();
  const [posts, setPosts] = useState([]);
  const [content, setContent] = useState("");
  const [err, setErr] = useState("");
  const [locked, setLocked] = useState(false);

  const load = async () => {
    setErr("");
    try {
      const { data } = await api.get("/community/posts");
      setPosts(data);
    } catch (e) {
      if (e.response?.status === 403) setLocked(true);
      else setErr(formatApiError(e.response?.data?.detail));
    }
  };

  useEffect(() => { if (user) load(); }, [user]);

  const submit = async () => {
    if (!content.trim()) return;
    try {
      await api.post("/community/posts", { content });
      setContent("");
      load();
    } catch (e) { setErr(formatApiError(e.response?.data?.detail)); }
  };

  if (!user) {
    return (
      <div className="max-w-xl mx-auto py-24 px-6 text-center" data-testid="community-signin">
        <h1 className="font-serif text-4xl text-[#F7ECEB]">Private space.</h1>
        <p className="text-[#A89896] mt-4">Sign in to enter the Touche community.</p>
        <Link to="/login" className="btn-primary inline-block mt-8">Sign in</Link>
      </div>
    );
  }

  if (locked) {
    return (
      <div className="max-w-xl mx-auto py-24 px-6 text-center" data-testid="community-locked">
        <h1 className="font-serif text-4xl text-[#F7ECEB]">Community is Member-only.</h1>
        <p className="text-[#A89896] mt-4">Upgrade from Basic to unlock the private community space.</p>
        <Link to="/membership" className="btn-primary inline-block mt-8">See membership</Link>
      </div>
    );
  }

  return (
    <div className="max-w-2xl mx-auto py-16 px-6" data-testid="community-page">
      <div className="text-xs uppercase tracking-[0.28em] text-[#C93B3B]">Community</div>
      <h1 className="font-serif text-5xl mt-4 text-[#F7ECEB]">A private circle.</h1>
      <p className="text-[#A89896] mt-4">Share reflections. Be gentle with one another.</p>

      <div className="tt-card p-6 mt-10">
        <textarea
          value={content} onChange={(e) => setContent(e.target.value)}
          rows={3} placeholder="What's on your heart today?"
          data-testid="community-input"
          className="w-full px-3 py-2 rounded-lg border border-[#382A2A] bg-[#1F1717]"
        />
        <div className="flex justify-end mt-3">
          <button onClick={submit} className="btn-primary" data-testid="community-submit">Post</button>
        </div>
      </div>

      {err && <div className="text-sm text-red-700 mt-4">{err}</div>}

      <div className="mt-10 space-y-4">
        {posts.map((p) => (
          <div key={p.id} className="tt-card p-6" data-testid={`community-post-${p.id}`}>
            <div className="text-xs text-[#C93B3B] uppercase tracking-[0.2em]">{p.author_name}</div>
            <p className="text-[#F7ECEB] mt-3 leading-relaxed">{p.content}</p>
          </div>
        ))}
        {posts.length === 0 && (
          <div className="text-center text-[#A89896] py-8">Be the first to share something today.</div>
        )}
      </div>
    </div>
  );
}
